import { useDispatch, useSelector } from "react-redux";
import { selectCurrentUser } from "modules/auth/store/authSlice";
import {
  resetNewOrderStatuses,
  saveAsDraftNewOrder,
  selectNewOrder
} from "modules/client/active-orders/store/orderSlice";
import { DEFAULT_STOP_ORDER_MODE } from "modules/client/active-orders/stopOrderModes";
import useClientReturnProcess from "modules/client/active-orders/components/return-process/useClientReturnProcess";
import React, { useContext, useEffect, useMemo, useState, useRef } from "react";
import { ProfileContext } from "layouts/private/ProfileContext";
import { useHistory } from "react-router-dom";
import moment from "moment/moment";
import { DAY_DATE_FORMAT } from "configs/constants";
import {
  Button,
  Col,
  Collapse,
  Form,
  Input,
  Modal,
  notification,
  Popconfirm,
  Row,
  Switch,
  Typography
} from "antd";
import { selectAllPackageTypes } from "modules/client/package-types/store/slice";
import { selectAllFlexioServices } from "modules/client/flexio-services/store/slice";
import { ReactSVG } from "react-svg";
import { getPackageTypeList } from "modules/client/package-types/store/thunks";
import { getFlexioServiceList } from "modules/client/flexio-services/store/thunks";
import {
  filterValidRoutes,
  getJobs,
  initRoutes,
  routeEstimateDefault
} from "modules/client/active-orders/helper";
import isEmpty from "lodash/isEmpty";
import { isInternalDriverService } from "modules/client/flexio-services/helper";
import uniq from "lodash/uniq";
import sumBy from "lodash/sumBy";
import {
  convertArrayToObject,
  convertObjectToArray,
  formatDateToBackend,
  handleTitleTab,
  makeId
} from "helper/util";
import { ROUTE_ESTIMATE_TYPES } from "modules/client/active-orders/constants";
import { doCreateActiveOrder } from "modules/client/active-orders/store/thunks";
import _find from "lodash/find";
import { setSuccessMessage } from "app/global/slice";
import OrdersHeader from "modules/client/active-orders/components/header/OrdersHeader";
import MapImportPreview from "modules/client/routes/components/maps/MapImportPreview";
import SiderForm from "modules/client/active-orders/components/SiderForm";
import AddressForm from "modules/client/active-orders/components/form/AddressForm";
import PackageList from "modules/client/active-orders/components/PackageList";
import PackageListDrop from "modules/client/active-orders/components/PackageListDrop";
import ServiceStep from "modules/client/active-orders/components/steps/ServiceStep";
import {
  ArrowLeftOutlined,
  ArrowRightOutlined,
  CheckCircleOutlined,
  CheckOutlined
} from "@ant-design/icons";
import PackForm from "modules/client/active-orders/components/form/PackForm";
import SelectPack from "modules/client/active-orders/components/form/SelectPack";
import { withPermission } from "hocs/withPermission";
import { UserRole } from "configs/constants";
import ImportLocations from "modules/client/routes/components/exports";
import { ImportIcon } from "components/svgs/ImportIcon";
import ConfirmRoutePage from "./ConfirmRoutePage";
import { DND_STATUSES } from "modules/shared/PickupDropoff/constants";
import warehouseApi from "modules/client/warehouses/api/warehouseApi";
import StepNavigationBar from "modules/client/active-orders/components/header/StepNavigationBar";
import StepContent from "modules/client/active-orders/components/StepContent";

const { Panel } = Collapse;

const { Paragraph } = Typography;

const routesInit = initRoutes();

const init = {
  id: `${new Date().getTime()}-${makeId(4)}` + ("Pickup" || "Dropoff"),
  title: "Pickup Location" || "Dropoff Location",
  position: 1,
  value: "text",
  address: { address: "", lngLat: [] },
  from_time: moment("08:00", "HH:mm"),
  to_time: moment("17:00", "HH:mm"),
  duration: 10,
  phone_numbers: [{ type: "contact", phone: "" }]
};

const pickupsInit = [
  {
    ...init,
    id: `${new Date().getTime()}-${makeId(4)}-Pickup`,
    title: "Pickup Location"
  }
];

const dropoffsInit = [
  {
    ...init,
    id: `${new Date().getTime()}-${makeId(4)}-Dropoff`,
    title: "Drop-off Location"
  }
];

const imagesInit = {
  pickups: {},
  dropoffs: {}
};

const breadCrumbs = [{ text: "ACTIVE ORDERS", url: "/routes" }, { text: "CREATE ORDER" }];

let isSelectRouteNumber;
let dndStatus;

const ClientCreateOrderPage = ({ isAdmin = false }) => {
  const dispatch = useDispatch();

  const currentUser = useSelector(selectCurrentUser);
  const newOrder = useSelector(selectNewOrder);
  const isLoading = useSelector((state) => state.global.isLoading);

  const profileCtx = useContext(ProfileContext);
  const history = useHistory();
  const profile = useMemo(() => profileCtx?.profile, [profileCtx]);
  const [clientId, setClientId] = useState();
  const [clientType, setClientType] = useState();
  const [driverId, setDriverId] = useState();
  const [jobs, setJobs] = useState({});
  const [routes, setRoutes] = useState(routesInit);
  const [pickupDate, setPickupDate] = useState(moment(new Date(), DAY_DATE_FORMAT));
  const [form] = Form.useForm();
  const [formPack] = Form.useForm();
  const [formSelectPack] = Form.useForm();
  const [packages, setPackages] = useState([]);
  const [pickups, setPickups] = useState(pickupsInit);
  const [dropoffs, setDropoffs] = useState(dropoffsInit);
  const [visible, setVisible] = useState(false);
  const [isAllPackage, setIsAllPackage] = useState(false);
  const [isOptimizeRoute, setIsOptimizeRoute] = useState(true);
  const [type, setType] = useState("pickups");
  const [selectedPack, setSelectedPack] = useState(null);
  const [keysPick, setKeysPick] = useState([pickupsInit[0].id]);
  const [keysDrop, setKeysDrop] = useState([dropoffsInit[0].id]);
  const [showImport, setShowImport] = useState(false);
  const [selectedInfo, setSelectedInfo] = useState({
    id: null,
    typePack: null
  });
  const [imagesAddressInfo, setImagesAddressInfo] = useState(imagesInit);
  const [idErrors, setIdErrors] = useState({
    pickups: [],
    dropoffs: []
  });
  const [isConfirmRoute, setIsConfirmRoute] = useState(false);
  const [confirmLocations, setConfirmLocations] = useState(false);
  const [inventoryPackagesByPickup, setInventoryPackagesByPickup] = useState({});
  const [warehousesByPickup, setWarehousesByPickup] = useState({});

  const packageTypeList = useSelector(selectAllPackageTypes);
  const allFlexioServices = useSelector(selectAllFlexioServices);

  // Filter services:
  // - For admins: exclude internal driver services
  // - For clients: show only services assigned by admin to their client
  const flexioServices = useMemo(() => {
    if (!allFlexioServices) return [];

    let filtered = allFlexioServices.filter(
      (service) => !isAdmin || !service.isInternalDriver
    );

    // For clients, only show services assigned to their account
    if (!isAdmin && profile?.client?.services) {
      const assignedServiceIds = profile.client.services.map((s) => s.id);
      filtered = filtered.filter((service) => assignedServiceIds.includes(service.id));
    }

    return filtered;
  }, [allFlexioServices, isAdmin, profile?.client?.services]);

  const [isEmptyPickupAddress, setIsEmptyPickupAddress] = useState(
    !pickups.map((pickup) => pickup.address.lngLat[0] !== undefined).every((item) => item)
  );
  const [isEmptyDropoffAddress, setIsEmptyDropoffAddress] = useState(
    !dropoffs
      .map((dropoff) => dropoff.address.lngLat[0] !== undefined)
      .every((item) => item)
  );

  const [isEmptyPhone, setIsEmptyPhone] = useState();

  const [collapseStepsActiveKey, setCollapseStepsActiveKey] = useState(1);
  const [confirmLocationsNext, setConfirmLocationsNext] = useState(false);
  const packFormRef = useRef(null);

  const isSubscriptionActive = useMemo(
    () => profileCtx?.isSubscriptionActive,
    [profileCtx]
  );
  const isProfileLoading = useMemo(() => profileCtx?.isLoading, [profileCtx]);

  useEffect(() => {
    // Check if coming from import (has action=new query param)
    const params = new URLSearchParams(window.location.search);
    const isFromImport = params.get("action") === "new";

    // Only redirect if profile is loaded AND subscription is inactive AND not from import
    if (!isProfileLoading && isSubscriptionActive === false && !isFromImport) {
      return history.push("/routes");
    }
  }, [isSubscriptionActive, isProfileLoading, history]);

  const expandIconDynamic = (props) => {
    if (props.isActive) {
      return <ReactSVG src="/icons/collapse.svg" />;
    } else {
      return <ReactSVG src="/icons/dropoff.svg" />;
    }
  };

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get("action") === "new") {
      dispatch(resetNewOrderStatuses());
    }
    // eslint-disable-next-line
  }, [dispatch]);

  const validateProfile = () => {
    const { firstName, lastName, email, phone } = profile;
    const {
      clientName,
      supportEmail,
      supportPhone,
      accountingEmail,
      market,
      industry,
      addressField1,
      country,
      lat,
      lng
    } = profile.client;

    let validateData;
    if (profile?.client.clientType === "organization") {
      validateData = [
        firstName,
        lastName,
        email,
        phone,
        clientName,
        supportEmail,
        supportPhone,
        accountingEmail,
        market,
        industry,
        addressField1,
        country,
        lat,
        lng
      ];
    } else {
      validateData = [
        firstName,
        lastName,
        email,
        phone,
        clientName,
        supportEmail,
        supportPhone,
        addressField1,
        country,
        lat,
        lng
      ];
    }
    const result = validateData.map((property) => property === "" || property === null);
    return result.includes(true);
  };

  useEffect(() => {
    dispatch(getPackageTypeList());
    dispatch(getFlexioServiceList());
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    let defaultPickups = newOrder.pickups || pickupsInit;
    let defaultDropoffs = newOrder.dropoffs || dropoffsInit;
    const defaultJobs = newOrder.jobs || {};
    const defaultRoutes = filterValidRoutes(newOrder.routes) || {};

    setClientId(newOrder?.clientId);
    setDriverId(newOrder?.driverId);
    setIsConfirmRoute(newOrder?.isConfirmRoute || false);
    // Only sync confirmLocations from Redux if explicitly set to true (e.g., from PlanListPage)
    // Don't overwrite local state if Redux value is false/undefined (normal flow)
    if (newOrder?.isConfirmLocations) {
      setConfirmLocations(newOrder.isConfirmLocations);
      setCollapseStepsActiveKey(null);
    }
    if (newOrder?.isConfirmRoute) {
      setCollapseStepsActiveKey(null);
      setType("service");
    }
    setJobs(defaultJobs);
    setRoutes(defaultRoutes);
    if (!isEmpty(newOrder)) {
      defaultPickups = defaultPickups.map((dPick) => ({
        ...dPick,
        locationNum: dPick?.locationNum || 0 + 1
      }));
      defaultDropoffs = defaultDropoffs.map((dDrop) => ({
        ...dDrop,
        locationNum: dDrop?.locationNum || 0 + 1
      }));

      setIsOptimizeRoute(newOrder.isOptimizeRoute);
      if (defaultPickups[0]) setKeysPick([defaultPickups[0].id]);
      if (defaultDropoffs[0]) setKeysDrop([defaultDropoffs[0].id]);
    }
    setPickupDate(
      newOrder.pickupDate
        ? moment(newOrder.pickupDate)
        : moment(new Date(), DAY_DATE_FORMAT)
    );

    setImagesAddressInfo(newOrder?.imagesAddressInfo || imagesInit);
    setPackages(newOrder.packages || []);
    setPickups(defaultPickups);
    setDropoffs(defaultDropoffs);
    setInventoryPackagesByPickup(newOrder?.inventoryPackagesByPickup || {});

    form.setFieldsValue({
      pickups: defaultPickups.map((pick) => {
        return {
          ...pick,
          from_time: pick.from_time ? moment(pick.from_time) : null,
          to_time: pick.to_time ? moment(pick.to_time) : null
        };
      }),
      dropoffs: defaultDropoffs.map((drop) => {
        return {
          ...drop,
          from_time: drop.from_time ? moment(drop.from_time) : null,
          to_time: drop.to_time ? moment(drop.to_time) : null
        };
      }),
      clientId: newOrder.clientId,
      driverId: newOrder.driverId
    });
  }, [form, newOrder]);

  const redirectUri = useMemo(
    () => "/orders/confirm-route",
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  const onChangeTypeMenu = async (value) => {
    setType(value.key);
    if (value.key !== "service" && !!idErrors[value.key].length) {
      setTimeout(() => {
        form
          .validateFields()
          .then(() => {})
          .catch(() => {});
      }, 1500);
    }
  };

  const validateRouteData = () => {
    const formPickups = form.getFieldValue("pickups") || [];
    const formDropoffs = form.getFieldValue("dropoffs") || [];
    const errorGroups = [];

    // Check if at least one pickup and dropoff exist
    if (formPickups.length === 0) {
      errorGroups.push({
        type: "General",
        errors: ["At least one pickup is required"]
      });
    }
    if (formDropoffs.length === 0) {
      errorGroups.push({
        type: "General",
        errors: ["At least one dropoff is required"]
      });
    }

    // Helper function to validate time format (HH:mm)
    const isValidTime = (time) => {
      if (!time) return false;
      // Handle moment objects
      if (moment.isMoment(time)) return time.isValid();
      // Handle string format
      const timeRegex = /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/;
      return timeRegex.test(time);
    };

    // Validate all pickups
    formPickups.forEach((pickup, index) => {
      const pickupNum = index + 1;
      const errors = [];

      if (!pickup?.address?.address) {
        errors.push("Address is required");
      }
      if (!isValidTime(pickup?.from_time)) {
        errors.push("Valid time window start is required (HH:mm format)");
      }
      if (!isValidTime(pickup?.to_time)) {
        errors.push("Valid time window end is required (HH:mm format)");
      }
      // Check if any packages exist for this pickup
      const hasPackages = packages.some((pack) => pack.pickupId === pickup.id);
      if (!hasPackages) {
        errors.push("At least one package is required");
      }

      // Check for unassigned packages for this pickup
      const unassignedCount = packages.filter(
        (pack) =>
          pack.pickupId === pickup.id && (!pack.dropoffs || pack.dropoffs.length === 0)
      ).length;
      if (unassignedCount > 0) {
        errors.push(
          `Has ${unassignedCount} unassigned package${unassignedCount > 1 ? "s" : ""}`
        );
      }

      if (errors.length > 0) {
        errorGroups.push({ type: `Pickup ${pickupNum}`, errors });
      }
    });

    // Validate all dropoffs
    formDropoffs.forEach((dropoff, index) => {
      const dropoffNum = index + 1;
      const errors = [];

      if (!dropoff?.address?.address) {
        errors.push("Address is required");
      }
      if (!isValidTime(dropoff?.from_time)) {
        errors.push("Valid time window start is required (HH:mm format)");
      }
      if (!isValidTime(dropoff?.to_time)) {
        errors.push("Valid time window end is required (HH:mm format)");
      }
      // Check if any packages have this dropoff assigned
      const hasPackages = packages.some(
        (pack) => pack.dropoffs && pack.dropoffs.some((drop) => drop.id === dropoff.id)
      );
      if (!hasPackages) {
        errors.push("At least one package is required");
      }

      if (errors.length > 0) {
        errorGroups.push({ type: `Dropoff ${dropoffNum}`, errors });
      }
    });

    return { isValid: errorGroups.length === 0, errorGroups };
  };

  const checkDataAdressForm = (data) => {
    const ids = [];
    const fieldRequired = [
      "address",
      "contact_name",
      "from_time",
      "to_time",
      "duration"
      // "phoneList"
    ];
    data.forEach((element) => {
      let isError = false;
      fieldRequired.forEach((field) => {
        let value = element[field];
        if (field === "address") value = element.address?.address;
        // if (field === "phoneList") {
        //   element.phone_numbers?.forEach((phone) => {
        //     if (!phone.phone) isError = true;
        //   });
        //   return;
        // }
        if (!isError && !value) isError = true;
      });
      if (isError) ids.push(element.id);
    });
    return ids;
  };

  const onFinishOrder = async () => {
    let messageError = [];

    if (validateProfile() === true) {
      messageError.push(
        "Error: You cannot create a job until you fill out your profile information. Please update your profile before proceeding."
      );
    }

    const { isValid, errorGroups } = validateRouteData();
    if (!isValid) {
      errorGroups.forEach((group) => {
        group.errors.forEach((error) => {
          messageError.push(`${group.type}: ${error}`);
        });
      });
    }

    const routeValidationMessages = checkRoutes();
    if (routeValidationMessages?.length)
      messageError = messageError.concat(routeValidationMessages);

    if (messageError.length) {
      const descriptionElement = (
        <Paragraph style={{ marginRight: 15 }}>
          <ul>
            {messageError.map((msg, i) => (
              <li key={`mess-${i}`}>{msg}</li>
            ))}
          </ul>
        </Paragraph>
      );
      notification.error({
        description: descriptionElement,
        placement: "topRight",
        style: {
          width: "auto"
        }
      });
    } else {
      saveData();
    }
  };

  const checkRoutes = () => {
    const routeErrors = [];
    const routeKeys = Object.keys(routes);
    if (routeKeys?.length) {
      for (const routeKey of routeKeys) {
        const route = routes[routeKey];
        if (!route?.vehicleCategoryId && !isInternalDriverService(route?.service?.name)) {
          routeErrors.push(`${route.name}: Please choose a Vehicle for the route `);
        }
        if (!route?.serviceId) {
          routeErrors.push(`${route.name}: Please choose a Service for the route`);
        }
      }
    }
    return routeErrors;
  };

  const checkPackages = () => {
    const pickupsIdsHasPack = uniq(packages.map((pack) => pack.pickupId));
    const picksNotPack = pickups.filter((p) => !pickupsIdsHasPack.includes(p.id)) || [];
    const messageError = [];
    if (picksNotPack.length) {
      `${picksNotPack.map((pick) => {
        if (pick) {
          messageError.push(
            `${pick.title} ${pick.position}: Please select some packages`
          );
        }
      })}`;
    }

    let isQuantityCurrent = false;
    if (!isAllPackage) {
      //console.log("isAllPackage", isAllPackage);

      packages.forEach((pack) => {
        const quantityCurrent = pack.quantity;
        if (pack?.dropoffs?.length) {
          const quantityTotal = sumBy(pack.dropoffs, "quantity");
          isQuantityCurrent = quantityCurrent - quantityTotal !== 0;
        } else {
          isQuantityCurrent = true;
        }
      });
    }
    if (isQuantityCurrent) {
      messageError.push("Some packages haven't been assigned to any drop-off");
    }

    return messageError;
  };

  const handleAddJobsToRoutes = () => {
    const tmpJobs = convertObjectToArray(jobs, "id");
    const unscheduledJobs = tmpJobs.filter((j) => j.routeId === "unscheduled");
    let tmpRoutes = {};
    Object.keys(newOrder.routes).map((key) => {
      // Do NOT gate this on routes[key].polylines. A route without map geometry is still a
      // real route: the "Bypass Routing Engine" stop-ordering mode returns no polyline at
      // all, and skipping this block left the route with no name and no jobs, which the
      // backend rejected as a bare 400 on POST /orders. Having jobs is the only condition
      // that matters here.
      {
        const findJobs = tmpJobs.filter((j) => j.routeId === key);
        if (findJobs?.length > 0) {
          tmpRoutes = {
            ...tmpRoutes,
            [key]: {
              ...newOrder.routes[key],
              // Return leg from the routing step, in the units the backend stores (m / s).
              // The backend only keeps it when returnToPickupEnabled is on.
              returnDistance: newOrder.routes[key]?.returnDistance || 0,
              returnDuration:
                newOrder.routes[key]?.returnDuration ||
                Math.round((newOrder.routes[key]?.returnMins || 0) * 60),
              jobs: findJobs
            }
          };
        }
      }
      console.log(
        `[FRONTEND ClientCreateOrder] Processing route ${key}, visibility from routes state:`,
        routes[key]?.visibility
      );
      tmpRoutes = {
        ...tmpRoutes,
        [key]: {
          ...tmpRoutes[key],
          serviceId: routes[key]?.serviceId,
          vehicleCategoryId: routes[key]?.vehicleCategoryId,
          vehicle: routes[key]?.vehicleCategory,
          clientEstimatePrice: routes[key]?.clientEstimatePrice,
          driverEstimatePrice: routes[key]?.driverEstimatePrice,
          visibility: routes[key]?.visibility || "all", // Add visibility field
          driverId: routes[key]?.driverId, // Per-route driver from the service step; blank = unassigned
          importFileId: newOrder?.importFileId, // Add import file ID from draft
          clientRouteEstimate: {
            ...(routes[key]?.clientRouteEstimate || routeEstimateDefault),
            type: ROUTE_ESTIMATE_TYPES.CLIENT_ESTIMATE
          },
          driverRouteEstimate: {
            ...(routes[key]?.driverRouteEstimate || routeEstimateDefault),
            type: ROUTE_ESTIMATE_TYPES.DRIVER_ESTIMATE
          }
        }
      };
      console.log(
        `[FRONTEND ClientCreateOrder] Route ${key} final object visibility:`,
        tmpRoutes[key].visibility
      );
    });

    if (unscheduledJobs?.length > 0) {
      tmpRoutes = {
        ...tmpRoutes,
        unscheduled: {
          name: "unscheduled",
          color: "#c4c4c4",
          jobs: unscheduledJobs
        }
      };
    }
    return convertObjectToArray(tmpRoutes, "id");
  };

  const saveData = async () => {
    const fields = {
      isOptimize: isOptimizeRoute,
      isSamePackages: isAllPackage,
      jobs: convertObjectToArray(newOrder?.jobs, "id"),
      routes: handleAddJobsToRoutes(),
      pickupDate: formatDateToBackend(pickupDate),
      userId: currentUser?.sub,
      clientId,
      driverId,
      inventoryPackagesByPickup,
      planId: newOrder?.fromPlanFlow ? newOrder?.planId : undefined,
      returnToPickupEnabled,
      returnOnFailedEnabled
    };

    console.log("===SAVE DATA - CLIENT CREATE ORDER PAGE===", {
      fromPlanFlow: newOrder?.isConfirmLocations === true,
      fields,
      newOrderState: newOrder
    });

    const { error } = await dispatch(await doCreateActiveOrder(fields));
    if (!error) {
      // The backend links the originating plan/tote to the newly created
      // route (RoutePlan.routeId) when planId is provided, so the plan/tote
      // is kept (not deleted) and can be viewed with a link to its route.

      form.resetFields();
      setImagesAddressInfo(imagesInit);
      dispatch(saveAsDraftNewOrder({}));
      // reset saved pickup date by clearing value
      localStorage.removeItem("pickupDate");
      history.push("/routes");
    }
  };

  const handleSelectPack = (values) => {
    const newPackages = [...packages];
    const packsData = values.packs;
    const packIds = values.packs.map((p) => p.id);
    packages.forEach((packa) => {
      if (!packIds.includes(packa.id)) return;
      const indexPack = newPackages.findIndex((newP) => packa.id === newP.id);
      const packSend = packsData.find((packD) => packa.id === packD.id);
      const existingDropoffs = newPackages[indexPack]?.dropoffs;
      const packDropoffs = existingDropoffs ? [...existingDropoffs] : [];
      const indexDrop = packDropoffs.findIndex((drop) => values.dropId === drop.id);
      if (packSend.value === 0 && indexDrop === -1) return;
      if (packSend.value === 0 && indexDrop !== -1) {
        packDropoffs.splice(indexDrop, 1);
      } else if (packDropoffs.length === 0) {
        packDropoffs.push({
          id: values.dropId,
          quantity: packSend.value
        });
      } else if (indexDrop === -1) {
        packDropoffs.push({
          id: values.dropId,
          quantity: packSend.value
        });
      } else {
        packDropoffs.splice(indexDrop, 1, {
          id: values.dropId,
          quantity: packSend.value
        });
      }
      newPackages[indexPack] = {
        ...newPackages[indexPack],
        dropoffs: packDropoffs
      };
      setPackages(newPackages);
    });
    onCancel();
  };

  const clickModal = () => {
    return selectedInfo.typePack !== "dropoff" ? formPack : formSelectPack;
  };

  const getPackForDrop = (dropId) => {
    if (isAllPackage) {
      return packages;
    } else {
      return packages.filter((pack) => {
        return (
          pack && pack.dropoffs?.length && pack.dropoffs.map((d) => d.id).includes(dropId)
        );
      });
    }
  };

  const getPacksFromSelect = (dropId) => {
    return packages.filter((pack) => {
      if (pack.dropoffs && pack.dropoffs.length) {
        const quantityCurrent = sumBy(
          pack.dropoffs.filter((drop) => drop.id !== dropId),
          "quantity"
        );
        return !(pack.quantity - quantityCurrent === 0);
      }
      return true;
    });
  };

  // NEW: Helper function to get dropoff location name
  const getDropoffLocationName = (dropId) => {
    const dropoff = dropoffs.find((d) => d.id === dropId);
    return (
      dropoff?.address?.location_name ||
      dropoff?.address?.address ||
      "No location selected"
    );
  };

  const onValuesChange = (changedFields, allFields) => {
    if (changedFields.pickups) {
      setPickups(allFields.pickups);
      setIsConfirmRoute(false);
    }
    if (changedFields.dropoffs) {
      setDropoffs(allFields.dropoffs);
      setIsConfirmRoute(false);
    }
  };

  const onchangeIsAllPackage = (checked, e) => {
    e.preventDefault();
    setIsAllPackage(checked);
    setIsConfirmRoute(false);
  };

  const handleSaveAsDraft = (callback = () => {}) => {
    if (isConfirmRoute) {
      dispatch(
        saveAsDraftNewOrder({
          data: {
            ...newOrder
          },
          callback
        })
      );
    } else {
      const dataForm = form.getFieldValue();
      // let defaultRoutes = newOrder?.routes || routesInit;
      const tmpJobs = getJobs({
        imagesAddressInfo,
        packages,
        pickups,
        dropoffs,
        isAllPackage,
        isOptimizeRoute
      });
      let firstPickup = {};
      if (dataForm.pickups[0]) {
        firstPickup = {
          ...dataForm.pickups[0]
        };
      }
      const objJobs = convertArrayToObject(tmpJobs, "id");
      setJobs(objJobs);
      dispatch(
        saveAsDraftNewOrder({
          data: {
            ...newOrder,
            pickups: dataForm.pickups,
            dropoffs: dataForm.dropoffs,
            isOptimizeRoute,
            imagesAddressInfo,
            isAllPackage,
            packages,
            pickupDate,
            jobs: objJobs,
            isConfirmRoute,
            firstPickup,
            clientId,
            driverId,
            inventoryPackagesByPickup
          },
          callback
        })
      );
    }

    dispatch(setSuccessMessage("Saved"));
  };

  /**
   * Writes everything the user has entered by hand — form values plus the local state the
   * form does not own — into the draft, with `extraData` merged in last.
   *
   * `saveAsDraftNewOrder` REPLACES the draft rather than merging into it, and the
   * `[form, newOrder]` effect re-seeds the form from whatever the draft ends up holding.
   * So any dispatch that spreads a `newOrder` which predates the manual entry silently
   * blanks the locations. Every such dispatch must go through here.
   */
  const saveManualDraft = (extraData = {}) => {
    const dataForm = form.getFieldValue();
    let tmpJobs = newOrder.jobs;
    let firstPickup = newOrder.firstPickup;
    if (!isConfirmRoute) {
      tmpJobs = getJobs({
        imagesAddressInfo,
        packages,
        pickups,
        dropoffs,
        isAllPackage,
        isOptimizeRoute
      });
      if (dataForm.pickups?.[0]) {
        firstPickup = {
          ...dataForm.pickups[0]
        };
      }
      tmpJobs = convertArrayToObject(tmpJobs, "id");
    }
    setJobs(tmpJobs);
    dispatch(
      saveAsDraftNewOrder({
        data: {
          ...newOrder,
          routes: { ...newOrder.routes },
          // Fall back to local state: on the confirm-locations step the <Form> itself is
          // not rendered, so never let an empty form read wipe the stops.
          pickups: dataForm.pickups || newOrder.pickups || pickups,
          dropoffs: dataForm.dropoffs || newOrder.dropoffs || dropoffs,
          isOptimizeRoute,
          imagesAddressInfo,
          isAllPackage,
          packages,
          pickupDate,
          jobs: tmpJobs,
          isConfirmRoute,
          firstPickup,
          clientId,
          driverId,
          inventoryPackagesByPickup,
          ...extraData
        }
      })
    );
  };

  const handleSaveAsDraftByManual = () => {
    saveManualDraft();
    dispatch(setSuccessMessage("Saved"));
  };

  const handleResetAll = () => {
    form.resetFields();
    setConfirmLocations(false);
    setConfirmLocationsNext(false);
    setType("pickups");
    setImagesAddressInfo(imagesInit);
    dispatch(saveAsDraftNewOrder({ data: {} }));
    dispatch(setSuccessMessage("Reset"));
    // reset saved pickup date by clearing value
    localStorage.removeItem("pickupDate");
    setIsAllPackage(true);
  };

  const changeCollapsePick = (props) => {
    setKeysPick([props]);
    const idsErrorPick = keysPick.filter((x) => idErrors.pickups.includes(x));
    if (idsErrorPick.length)
      setTimeout(() => {
        form
          .validateFields()
          .then(() => {})
          .catch(() => {});
      }, 1500);
  };

  const changeCollapsDrop = (props) => {
    setKeysDrop([props]);
    const idsErrorDrop = keysDrop.filter((x) => idErrors.dropoffs.includes(x));
    if (idsErrorDrop.length)
      setTimeout(() => {
        form
          .validateFields()
          .then(() => {})
          .catch(() => {});
      }, 1500);
  };
  const addPickup = () => {
    const pickupsForm = form.getFieldValue("pickups");
    const maxPosition = Math.max(...pickupsForm.map((p) => p.position), 1);
    return {
      ...init,
      id: `${new Date().getTime()}-${makeId(4)}-Pickup`,
      title: "Pickup Location",
      position: maxPosition + 1
    };
  };

  const addDropoff = () => {
    const dropoffsForm = form.getFieldValue("dropoffs");

    // unlock option to edit packages after 1st addDropoff
    setIsAllPackage(false);

    const maxPosition = Math.max(...dropoffsForm.map((p) => p.position), 1);
    return {
      ...init,
      id: `${new Date().getTime()}-${makeId(4)}-Dropoff`,
      title: "Drop-off Location",
      position: maxPosition + 1
    };
  };

  const handleHeader = (pickup, index, name, remove, array, stepType) => {
    const pickupId = parseInt(pickup?.id);
    let stopPacks = packages.filter((pa) => pa.pickupId.toString().includes(pickupId));
    let newArr = array.map((arr) => arr && parseInt(arr));
    let packagesQty = 0;

    if (stepType !== "dropoffs") {
      packagesQty = stopPacks.reduce((acc, curr) => {
        return acc + parseInt(curr.quantity);
      }, 0);
    } else {
      // This will help show correct quantity of packages per dropoffs
      let drops = packages.find((pack) => pack?.dropoffs)
        ? packages.map((packDrop) => packDrop.dropoffs)
        : [{}];
      drops = [].concat(...drops);
      drops = [drops[index]];

      packagesQty = drops.reduce((acc, curr) => {
        return acc + parseInt(curr?.quantity || 0);
      }, 0);
    }

    return (
      <div className="header-collapse">
        <div className="top">
          <div>
            {newArr?.includes(pickupId) ? (
              <>
                <h3 className="mb-4">
                  {pickup?.title || pickup?.type || "Pickup Location 1"} {index + 1}
                </h3>
                <p className="simple-text">
                  Enter {stepType === "pickups" ? "pickup" : "dropoff"} details.
                </p>
              </>
            ) : (
              <>
                <h3 className="mb-4">
                  {pickup?.title || pickup?.type || "Pickup Location 1"} {index + 1}
                </h3>
                <Row gutter={5}>
                  <Col md={24}>
                    <p className="header-text">
                      <span>
                        <strong>{pickup?.location_name || ""}</strong>{" "}
                      </span>
                      <span className="header-sub-text">{pickup?.address.address}</span>
                    </p>
                    <p className="header-text">{pickup?.contact_name || ""}</p>
                    <p className="header-text">
                      {packagesQty ? packagesQty + " Packages" : pickup.quantity}
                    </p>
                    {pickup?.address.address && (
                      <Button className="action-button">Edit Location</Button>
                    )}
                  </Col>
                </Row>
              </>
            )}
          </div>
        </div>
        {index > 0 && (
          <Popconfirm
            title="Are you sure you want to delete this location?"
            onConfirm={(e) => {
              handleClickDeletePickup(name, remove, e, pickup.id, stepType);
            }}
            okText="Yes"
            cancelText="No"
          >
            <ReactSVG
              className="icon"
              src="/icons/delete-icon.svg"
              style={{
                top: "3px"
              }}
              onClick={(e) => e.stopPropagation()}
            />
          </Popconfirm>
        )}
      </div>
    );
  };

  const onCancel = () => {
    if (packFormRef.current?.packageSourceSelection === "warehouse") {
      packFormRef.current?.handleWarehouseCancel();
    }
    formPack.resetFields();
    setSelectedPack(null);
    setSelectedInfo({});
    setVisible(false);
  };

  const openPackCreateUpdate = (
    ac,
    id,
    typePack,
    pack = null,
    warehouseOnly = false,
    customOnly = false
  ) => {
    const pickupsForm = form.getFieldValue("pickups");
    const currentPickup = pickupsForm.find((pickup) => pickup.id === id);

    const isWarehousePack = pack?.inventoryItemId;
    const isCustomPack = pack && !pack.inventoryItemId;

    setVisible(true);
    setSelectedPack(pack);
    setSelectedInfo({
      id,
      typePack,
      savedLocationId: currentPickup?.savedLocationId,
      warehouseOnly: warehouseOnly || isWarehousePack,
      customOnly: customOnly || isCustomPack
    });
    setIsConfirmRoute(false);
  };

  const openSelectedPack = (dropId) => {
    setSelectedInfo({
      id: dropId,
      typePack: "dropoff"
    });
    setVisible(true);
    setIsConfirmRoute(false);
  };

  const handleSavePack = (values) => {
    const pickupId = selectedInfo?.id;
    const newPackages = [...packages];

    if (values.inventoryItemId) {
      const existingWarehousePackIndex = newPackages.findIndex(
        (pack) =>
          pack.pickupId === pickupId &&
          pack.inventoryItemId &&
          pack.packageTypeId === values.packageTypeId
      );

      if (existingWarehousePackIndex !== -1 && !values.id) {
        const existingPack = newPackages[existingWarehousePackIndex];
        const allSerials = [
          ...(existingPack.inventoryItemSerials || []),
          ...(values.inventoryItemSerials || [])
        ];
        const uniqueSerials = allSerials.filter(
          (serial, index, self) =>
            index === self.findIndex((s) => s.serialNumber === serial.serialNumber)
        );

        newPackages[existingWarehousePackIndex] = {
          ...existingPack,
          inventoryItemSerials: uniqueSerials,
          quantity: uniqueSerials.length
        };

        const updatedInventoryPackages = {
          ...inventoryPackagesByPickup,
          [pickupId]: {
            ...(inventoryPackagesByPickup[pickupId] || {}),
            [existingPack.id]: {
              inventoryItemId: existingPack.inventoryItemId,
              serials: uniqueSerials
            }
          }
        };
        setInventoryPackagesByPickup(updatedInventoryPackages);
      } else if (values.id) {
        const indexpack = newPackages.findIndex((pack) => pack.id === values.id);
        delete values.id;
        const newPack = {
          ...newPackages[indexpack],
          ...values
        };
        newPackages.splice(indexpack, 1, newPack);

        const updatedInventoryPackages = {
          ...inventoryPackagesByPickup,
          [pickupId]: {
            ...(inventoryPackagesByPickup[pickupId] || {}),
            [newPackages[indexpack].id]: {
              inventoryItemId: values.inventoryItemId,
              serials: values.inventoryItemSerials || []
            }
          }
        };
        setInventoryPackagesByPickup(updatedInventoryPackages);
      } else {
        const newPackageId = `${new Date().getTime()}-${pickupId}pack`;
        newPackages.push({
          ...values,
          pickupId: pickupId,
          id: newPackageId
        });

        const updatedInventoryPackages = {
          ...inventoryPackagesByPickup,
          [pickupId]: {
            ...(inventoryPackagesByPickup[pickupId] || {}),
            [newPackageId]: {
              inventoryItemId: values.inventoryItemId,
              serials: values.inventoryItemSerials || []
            }
          }
        };
        setInventoryPackagesByPickup(updatedInventoryPackages);
      }
    } else {
      if (!values.id) {
        const newPackageId = `${new Date().getTime()}-${pickupId}pack`;
        newPackages.push({
          ...values,
          pickupId: pickupId,
          id: newPackageId
        });
      } else {
        const indexpack = newPackages.findIndex((pack) => pack.id === values.id);
        delete values.id;
        const newPack = {
          ...newPackages[indexpack],
          ...values
        };
        newPackages.splice(indexpack, 1, newPack);
      }
    }

    setPackages(newPackages);
    onCancel();
  };

  const removePack = (values) => {
    const newPackages = [...packages];
    const indexpack = newPackages.findIndex((pack) => pack.id === values.id);
    const packageToRemove = newPackages[indexpack];
    newPackages.splice(indexpack, 1);
    setPackages(newPackages);
    if (packageToRemove && packageToRemove.pickupId) {
      const updatedInventoryPackages = { ...inventoryPackagesByPickup };
      if (updatedInventoryPackages[packageToRemove.pickupId]) {
        delete updatedInventoryPackages[packageToRemove.pickupId][packageToRemove.id];
        if (
          Object.keys(updatedInventoryPackages[packageToRemove.pickupId]).length === 0
        ) {
          delete updatedInventoryPackages[packageToRemove.pickupId];
        }
      }
      setInventoryPackagesByPickup(updatedInventoryPackages);
    }
  };

  const checkWarehousesForPickup = async (pickupId, savedLocationId) => {
    if (!savedLocationId) return;
    try {
      const warehouses = await warehouseApi.getWarehousesByLocation(savedLocationId);
      setWarehousesByPickup((prev) => ({
        ...prev,
        [pickupId]: warehouses || []
      }));
    } catch (error) {
      console.error("Error checking warehouses:", error);
      setWarehousesByPickup((prev) => ({
        ...prev,
        [pickupId]: []
      }));
    }
  };

  const onChangePickupLocationSearch = (value, pickupId) => {
    const pickupsForm = [...form.getFieldValue("pickups")];
    const indexPickup = pickupsForm.findIndex((pickup) => pickup.id === pickupId);
    pickupsForm[indexPickup].location_name = value;
    setPickups(pickupsForm);
  };
  const onChangeDropoffLocationSearch = (value, pickupId) => {
    const dropoffsFrom = [...form.getFieldValue("dropoffs")];
    const indexDropoff = dropoffsFrom.findIndex((pickup) => pickup.id === pickupId);
    dropoffsFrom[indexDropoff].location_name = value;
    setDropoffs(dropoffsFrom);
  };

  const onChangePickupAddress = (value, pickupId) => {
    const pickupsFrom = [...form.getFieldValue("pickups")];
    const indexPickup = pickupsFrom.findIndex((pickup) => pickup.id === pickupId);
    const pickupFrom = { ...pickupsFrom[indexPickup] };
    if (pickupFrom) {
      pickupFrom.address = {
        address: value.address,
        lngLat: value.lngLat
      };
      pickupsFrom.splice(indexPickup, 1, pickupFrom);
      form.setFieldsValue({
        pickups: pickupsFrom
      });
      setPickups(pickupsFrom);
    }
    setIsConfirmRoute(false);
  };

  const onChangeDropoffAddress = (value, dropoffId) => {
    const dropoffFrom = [...form.getFieldValue("dropoffs")];
    const indexDropoff = dropoffFrom.findIndex((dropoff) => dropoff.id === dropoffId);
    const pickupFrom = { ...dropoffFrom[indexDropoff] };
    if (pickupFrom) {
      pickupFrom.address = {
        address: value.address,
        lngLat: value.lngLat
      };
      dropoffFrom.splice(indexDropoff, 1, pickupFrom);
      form.setFieldsValue({
        dropoffs: dropoffFrom
      });
      setDropoffs(dropoffFrom);
    }
    setIsConfirmRoute(false);
  };

  useEffect(() => {
    setIsEmptyPickupAddress(
      !pickups
        .map((pickup) => pickup.address.lngLat[0] !== undefined)
        .every((item) => item)
    );
  }, [pickups]);
  useEffect(() => {
    setIsEmptyDropoffAddress(
      !dropoffs
        .map((dropoff) => dropoff.address.lngLat[0] !== undefined)
        .every((item) => item)
    );
  }, [pickups, dropoffs, packages]);

  useEffect(() => {
    const hasEmptyPhone = (items) => {
      return items.some(
        (item) =>
          !item.phone_numbers ||
          item.phone_numbers.length === 0 ||
          item.phone_numbers.some(
            (phoneObj) => !phoneObj.phone || phoneObj.phone.trim() === ""
          )
      );
    };

    const dropoffsHasEmpty = hasEmptyPhone(dropoffs);
    const pickupsHasEmpty = hasEmptyPhone(pickups);

    setIsEmptyPhone(dropoffsHasEmpty || pickupsHasEmpty);
  }, [dropoffs, pickups]);

  const onChangeTime = (value, id, name, fieldName) => {
    const dropoffFrom = [...form.getFieldValue(name)];
    const indexDropoff = dropoffFrom.findIndex((dropoff) => dropoff.id === id);
    const pickupFrom = { ...dropoffFrom[indexDropoff] };
    const tmpObject = {};
    if (pickupFrom) {
      pickupFrom[fieldName] = value;
      dropoffFrom.splice(indexDropoff, 1, pickupFrom);
      tmpObject[name] = dropoffFrom;
      form.setFieldsValue(tmpObject);
      name === "pickups" ? setPickups(dropoffFrom) : setDropoffs(dropoffFrom);
    }
    setIsConfirmRoute(false);
  };

  const handleClickDeletePickup = (name, actionFunc, e, id, stepType) => {
    e.stopPropagation();
    if (stepType === "pickups") {
      const deletePackIds =
        packages.filter((pack) => pack.pickupId === id)?.map((p) => p.id) || [];
      const newPacks = packages.filter((pack) => !deletePackIds.includes(pack.id));
      setPackages(newPacks);
    } else {
      const packsHasDrop =
        packages.filter(
          (pack) => pack.dropoffs?.length > 0 && pack.dropoffs.find((d) => d.id === id)
        ) || [];
      if (packsHasDrop.length) {
        const newPacks = packages.map((pack) => ({
          ...pack,
          dropoffs: [...(pack.dropoffs || [])]
        }));
        packsHasDrop.forEach((packD) => {
          const packIndex = packages.findIndex((pa) => pa.id === packD.id);
          if (packIndex !== -1) {
            // Remove the dropoff by filtering it out (instead of splice)
            newPacks[packIndex].dropoffs = newPacks[packIndex].dropoffs.filter(
              (d) => d.id !== id
            );
          }
        });
        setPackages(newPacks);
      }
    }
    actionFunc(name);
    setIsConfirmRoute(false);
  };

  const handleClickService = () => {
    const { isValid, errorGroups } = validateRouteData();
    if (!isValid) {
      notification.destroy();
      return notification.error({
        message: "Missing Required Fields",
        description: (
          <div>
            <p>The following fields are required for route optimization:</p>
            <div style={{ marginTop: 8 }}>
              {errorGroups.map((group, i) => (
                <div key={i} style={{ marginBottom: 12 }}>
                  <strong>{group.type}:</strong>
                  <ul style={{ marginTop: 4, marginBottom: 0, paddingLeft: 20 }}>
                    {group.errors.map((error, j) => (
                      <li key={j}>{error}</li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>
        ),
        placement: "topRight",
        duration: 6,
        style: { width: "auto" }
      });
    }
    dispatch(
      saveAsDraftNewOrder({
        data: {
          ...newOrder, // Keep other data as is
          isConfirmRoute: false // Reset to trigger re-optimization
        }
      })
    );
    // Reset order statuses to trigger re-optimization
    dispatch(resetNewOrderStatuses());
    setConfirmLocations(true);
    setCollapseStepsActiveKey(3);
    handleSaveAsDraft(() => null);
  };

  /**
   * Persists the Step 2 stop-ordering choice on the draft and clears the confirmed-route
   * flag, so changing it re-runs the optimization step rather than showing a stale plan.
   *
   * Goes through saveManualDraft rather than spreading `newOrder` directly: the picker
   * modal opens as soon as Step 2 mounts, and for a hand-entered order the draft can still
   * be behind the form at that moment. Spreading it here blanked the locations.
   */
  const handleChangeStopOrderMode = (stopOrderMode) => {
    saveManualDraft({ stopOrderMode, isConfirmRoute: false });
    dispatch(resetNewOrderStatuses());
  };

  // Return Process for this order (see ReturnProcessSelect). Seeded from the client's
  // Settings > Return Process defaults; the choice lives in the draft so the pricing step
  // and the final POST /orders see the same values.
  const clientReturnProcess = useClientReturnProcess({ clientId, isAdmin: false });
  const returnToPickupEnabled =
    newOrder?.returnToPickupEnabled ?? clientReturnProcess.defaults.returnToPickupEnabled;
  const returnOnFailedEnabled =
    newOrder?.returnOnFailedEnabled ?? clientReturnProcess.defaults.returnOnFailedEnabled;
  const handleChangeReturnProcess = (values) => {
    saveManualDraft(values);
  };
  const returnProcessProps = {
    returnToPickupEnabled,
    returnOnFailedEnabled,
    defaults: clientReturnProcess.defaults,
    settings: clientReturnProcess.settings,
    loading: clientReturnProcess.loading,
    clientMissing: false,
    onChange: handleChangeReturnProcess
  };

  const handleConfirmRouteOptimization = () => {
    dispatch(
      saveAsDraftNewOrder({
        data: {
          ...newOrder,
          routes: filterValidRoutes(newOrder.routes),
          isConfirmRoute: true,
          isConfirmLocations: true
        }
      })
    );
    redirectToNewJobsPageAgain();
  };

  const redirectToNewJobsPageAgain = () => {
    //console.log("redirect");
  };

  // Calculate current step from state flags
  const getCurrentStep = () => {
    // Step 1: Initial state (no flags set)
    if (!confirmLocationsNext && !confirmLocations && !isConfirmRoute) {
      return 1;
    }
    // Step 2: Confirm locations (map view)
    if (confirmLocationsNext && !confirmLocations && !isConfirmRoute) {
      return 2;
    }
    // Step 3: Route optimization
    if (confirmLocations && !isConfirmRoute) {
      return 3;
    }
    // Step 4: Final confirmation / Service selection
    if (isConfirmRoute) {
      return 4;
    }
    return 1;
  };

  // Handle backward navigation via step bar
  const handleStepNavigation = (stepNumber) => {
    if (stepNumber === 1) {
      // Go back to step 1 (locations entry)
      setCollapseStepsActiveKey(1);
      setConfirmLocationsNext(false);
      setConfirmLocations(false);
      setIsConfirmRoute(false);
      setType("pickups");
    } else if (stepNumber === 2) {
      // Go back to step 2 (confirm locations map)
      setCollapseStepsActiveKey(3);
      setConfirmLocationsNext(true);
      setConfirmLocations(false);
      setIsConfirmRoute(false);
    } else if (stepNumber === 3) {
      // Go to step 3 (route optimization) - reset order state to trigger re-optimization
      setCollapseStepsActiveKey(null);
      setConfirmLocationsNext(false);
      setConfirmLocations(true);
      setIsConfirmRoute(false);

      // Reset the order state to trigger re-optimization
      dispatch(
        saveAsDraftNewOrder({
          data: {
            ...newOrder,
            isConfirmRoute: false
          }
        })
      );
      dispatch(resetNewOrderStatuses());
    }
  };

  return (
    <div className="CreateOrderPage">
      <div className="wrapper">
        <div className="contentForm">
          <div className="order-create-container">
            <div
              style={{
                padding: "0 1em 6px 1em",
                top: -15
              }}
              className="sticky-wrapper"
            >
              <div className="title-container">
                <h2 className="page-title">Plan Your Delivery Routes</h2>
                <p>
                  Create, optimize, and upload routes for efficient delivery management.
                </p>
              </div>
              <StepNavigationBar
                currentStep={getCurrentStep()}
                isAdmin={isAdmin}
                onStepClick={handleStepNavigation}
              />
            </div>
            <StepContent
              currentStep={getCurrentStep()}
              isAdmin={isAdmin}
              clientId={clientId}
              flexioServices={flexioServices}
              pickupDate={pickupDate}
              setPickupDate={setPickupDate}
              clientType={clientType}
              routes={routes}
              setRoutes={setRoutes}
              form={form}
              pickups={pickups}
              dropoffs={dropoffs}
              packages={packages}
              onValuesChange={onValuesChange}
              setShowImport={setShowImport}
              onChangePickupAddress={onChangePickupAddress}
              onChangePickupLocationSearch={onChangePickupLocationSearch}
              checkWarehousesForPickup={checkWarehousesForPickup}
              onChangeTime={onChangeTime}
              imagesAddressInfo={imagesAddressInfo}
              setImagesAddressInfo={setImagesAddressInfo}
              addPickup={addPickup}
              onChangeDropoffAddress={onChangeDropoffAddress}
              onChangeDropoffLocationSearch={onChangeDropoffLocationSearch}
              getPackForDrop={getPackForDrop}
              openSelectedPack={openSelectedPack}
              isAllPackage={isAllPackage}
              addDropoff={addDropoff}
              openPackCreateUpdate={openPackCreateUpdate}
              removePack={removePack}
              warehousesByPickup={warehousesByPickup}
              idErrors={idErrors}
              pickupsInit={pickupsInit}
              dropoffsInit={dropoffsInit}
              type={type}
              isConfirmRoute={isConfirmRoute}
              packageTypeList={packageTypeList}
              stopOrderMode={newOrder?.stopOrderMode || DEFAULT_STOP_ORDER_MODE}
              setStopOrderMode={handleChangeStopOrderMode}
              preferredNoOfStops={profile?.client?.preferredNoOfStops}
              returnProcess={returnProcessProps}
            />
          </div>
        </div>
      </div>

      <div className="footer">
        <div>
          <Button
            size="large"
            onClick={() => {
              // Go back one step instead of exiting
              if (!confirmLocationsNext && !confirmLocations && !isConfirmRoute) {
                // Already at step 1, can't go back
                return;
              } else if (confirmLocationsNext && !confirmLocations && !isConfirmRoute) {
                // At step 2, go back to step 1
                handleStepNavigation(1);
              } else if (confirmLocations && !isConfirmRoute) {
                // At step 3, go back to step 2
                handleStepNavigation(2);
              } else if (isConfirmRoute) {
                // At step 4, go back to step 3
                handleStepNavigation(3);
              }
            }}
          >
            <ArrowLeftOutlined /> Go Back
          </Button>
        </div>
        <div>
          <Button size="large" onClick={handleResetAll}>
            Reset
          </Button>
        </div>
        <div>
          {isConfirmRoute && (
            <Button
              size="large"
              className="svg-icon modify"
              type="link"
              onClick={() => {
                // This will reset to step 2
                dispatch(
                  saveAsDraftNewOrder(
                    {
                      data: {
                        ...newOrder,
                        // Set isConfirmRoute because it will keep showing step 4
                        isConfirmRoute: false
                      }
                    },
                    () => null
                  )
                );
                setCollapseStepsActiveKey(1);
                setIsConfirmRoute(false);
                setConfirmLocations(false);
                setConfirmLocationsNext(false);
                setType("pickups");
              }}
            >
              Modify Route <ReactSVG src="/icons/edit_road.svg" className="icon" />
            </Button>
          )}

          <Button
            size="large"
            className="save-as"
            onClick={() => handleSaveAsDraftByManual()}
          >
            Save as Draft <ReactSVG src="/icons/draf.svg" className="icon" />
          </Button>
          {/* <Button
            type="primary"
            size="large"
            className="create-order"
            onClick={isConfirmRoute ? onFinishOrder : handleClickService}
            loading={isLoading}
          >
            {isConfirmRoute ? "Confirm Selected Service" : "Confirm Route"}
            <CheckCircleOutlined />
          </Button> */}
        </div>
        {!confirmLocationsNext && (
          <Button
            style={{
              backgroundColor: "#15BCE8",
              color: "#fff",
              border: 0,
              padding: 8
            }}
            onClick={() => {
              const { isValid, errorGroups } = validateRouteData();

              if (!isValid) {
                notification.destroy();
                return notification.error({
                  message: "Missing Required Fields",
                  description: (
                    <div>
                      <p>The following fields are required for route optimization:</p>
                      <div style={{ marginTop: 8 }}>
                        {errorGroups.map((group, i) => (
                          <div key={i} style={{ marginBottom: 12 }}>
                            <strong>{group.type}:</strong>
                            <ul
                              style={{ marginTop: 4, marginBottom: 0, paddingLeft: 20 }}
                            >
                              {group.errors.map((error, j) => (
                                <li key={j}>{error}</li>
                              ))}
                            </ul>
                          </div>
                        ))}
                      </div>
                    </div>
                  ),
                  placement: "topRight",
                  duration: 6,
                  style: {
                    width: "auto"
                  }
                });
              }

              handleSaveAsDraftByManual();
              setCollapseStepsActiveKey(2);
              setConfirmLocationsNext(true);
            }}
          >
            Next Step <ArrowRightOutlined />
          </Button>
        )}
        {confirmLocationsNext && !confirmLocations && (
          <Button
            style={{
              backgroundColor: "#15BCE8",
              color: "#fff",
              border: 0,
              padding: 10
            }}
            onClick={handleClickService}
            loading={isLoading}
          >
            Confirm Locations Added
          </Button>
        )}
        {!isConfirmRoute && confirmLocations && (
          <Button
            style={{
              backgroundColor: "#15BCE8",
              color: "#fff",
              border: 0,
              padding: 10
            }}
            className="confirm-button"
            onClick={handleConfirmRouteOptimization}
            disabled={
              isSelectRouteNumber ||
              [DND_STATUSES.SORT, DND_STATUSES.OPTIMIZE].includes(dndStatus)
            }
          >
            Confirm Route Optimization
          </Button>
        )}
        {type === "service" && (
          <Button
            style={{
              backgroundColor: "#15BCE8",
              color: "#fff",
              border: 0,
              padding: 10
            }}
            onClick={onFinishOrder}
            loading={isLoading}
          >
            Confirm Routes
          </Button>
        )}
      </div>
      <Modal
        title={
          !selectedPack && selectedInfo.typePack !== "dropoff" ? (
            <div>Add Package</div>
          ) : selectedPack && selectedInfo.typePack !== "dropoff" ? (
            <div>Edit Package</div>
          ) : (
            <div>Select Package</div>
          )
        }
        visible={visible}
        onCancel={onCancel}
        footer={
          <div className="buttons-modal">
            <Form.Item>
              <Button size="large" onClick={onCancel}>
                Cancel
              </Button>
              <Button
                size="large"
                type="primary"
                onClick={() => {
                  if (packFormRef.current?.packageSourceSelection === "warehouse") {
                    packFormRef.current?.handleWarehouseConfirm();
                  } else {
                    clickModal().submit();
                  }
                }}
              >
                Confirm
                <CheckCircleOutlined />
              </Button>
            </Form.Item>
          </div>
        }
        width={792}
      >
        {selectedInfo.typePack !== "dropoff" && (
          <PackForm
            ref={packFormRef}
            pack={selectedPack}
            formPack={formPack}
            onOk={handleSavePack}
            packageTypeList={packageTypeList}
            pickupLocationId={selectedInfo.savedLocationId}
            currentPickupId={selectedInfo.id}
            inventoryPackagesByPickup={inventoryPackagesByPickup}
            pickups={pickups}
            onCancel={onCancel}
            warehouseOnly={selectedInfo.warehouseOnly}
            customOnly={selectedInfo.customOnly}
            visible={visible}
          />
        )}
        {selectedInfo.typePack === "dropoff" && (
          <SelectPack
            packages={getPacksFromSelect(selectedInfo.id)}
            packageTypeList={packageTypeList}
            formSelectPack={formSelectPack}
            dropId={selectedInfo.id}
            dropoffAddress={getDropoffLocationName(selectedInfo.id)}
            pickups={pickups}
            dropoffs={dropoffs}
            onOk={handleSelectPack}
          />
        )}
      </Modal>
      <Modal
        open={showImport}
        closable={false}
        className="no-padding-modal import-modal"
        onCancel={() => setShowImport(false)}
        footer={false}
        centered={true}
        zIndex={1000}
      >
        <ImportLocations handleCloseModal={() => setShowImport(false)} />
      </Modal>
    </div>
  );
};
export default withPermission(ClientCreateOrderPage, [UserRole.ADMIN, UserRole.MANAGER]);
